import { Users, MessageSquare, Backpack, Car, Wallet, ListChecks, Navigation } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { SectionHeading } from "@/components/PageIntro";

export const FEATURES = [
  { Icon: Users, title: "Gruppen", desc: "Plane mit deiner gesamten Crew.", color: "#8B5CF6", group: "Organisation" },
  { Icon: MessageSquare, title: "Gruppenchat", desc: "Alle Informationen an einem Ort.", color: "#00E5FF", group: "Kommunikation" },
  { Icon: Backpack, title: "Packliste", desc: "Jeder übernimmt seine Sachen.", color: "#22C55E", group: "Organisation" },
  { Icon: Car, title: "Fahrgemeinschaft", desc: "Plane Sitzplätze und Fahrzeuge.", color: "#FACC15", group: "Unterwegs" },
  { Icon: Wallet, title: "Gruppenkasse", desc: "Behalte alle Ausgaben im Blick.", color: "#8B5CF6", group: "Finanzen" },
  { Icon: ListChecks, title: "Aufgaben", desc: "Nie wieder vergessen wer was erledigt.", color: "#00E5FF", group: "Organisation" },
  { Icon: Navigation, title: "FestivalNavigator", desc: "Teile Camp, Bühne & Treffpunkte live mit deiner Crew.", color: "#00E5FF", group: "Unterwegs" },
];

export function FeatureRow({ Icon, title, desc, color, index }) {
  return (
    <div data-testid={`feature-card-${index}`} className="flex gap-4 py-6">
      <span
        className="mt-0.5 grid h-10 w-10 shrink-0 place-items-center rounded-lg border border-white/10"
        style={{ background: `${color}14` }}
      >
        <Icon className="h-5 w-5" style={{ color }} />
      </span>
      <div>
        <h3 className="font-display text-lg font-semibold text-white">{title}</h3>
        <p className="mt-1 text-sm leading-relaxed text-white/55">{desc}</p>
      </div>
    </div>
  );
}

export default function Features({ footer }) {
  return (
    <section id="features" data-testid="features-section" className="border-b border-white/10">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:px-8 lg:py-24">
        <Reveal>
          <SectionHeading
            eyebrow="Features"
            title="Alles, was eure Crew braucht."
            lead="Sechs Werkzeuge, die WhatsApp-Gruppen, Excel-Listen und Zettelchaos ersetzen."
          />
        </Reveal>
        <Reveal delay={0.05}>
          <div className="mt-10 grid grid-cols-1 divide-y divide-white/10 border-t border-white/10 sm:grid-cols-2 sm:gap-x-12 sm:divide-y-0 lg:grid-cols-3">
            {FEATURES.map((f, i) => (
              <div key={f.title} className="sm:border-b sm:border-white/10">
                <FeatureRow {...f} index={i} />
              </div>
            ))}
          </div>
        </Reveal>
        {footer && <div className="mt-10">{footer}</div>}
      </div>
    </section>
  );
}
